module.exports = __webpack_public_path__ + "img/交流壁挂.7a1205e1.png";